const apiRequestReducer = (previousState, action) => {
  switch (action.type) {
    case "uninitialize":
      return {
        readyState: "uninitialized",
        isFinished: false,
        isLoading: false
      };
    case "initialize":
      return {
        readyState: "pending",
        isFinished: false,
        isLoading: true
      };
    case "resolveSuccessfully":
      return {
        readyState: "networkSuccess",
        data: action.data,
        isFinished: true,
        isLoading: false
      };
    case "resolveWithError":
      return {
        readyState: "networkError",
        data: action.error,
        isFinished: true,
        isLoading: false
      };
  }
};
export {
  apiRequestReducer
};
//# sourceMappingURL=apiRequestReducer.js.map
